import { CityDetailsResult, PartialSearchMaskLocation } from 'app/models/types/store/location';
import { getSelectedProductsAmount } from 'app/functions';
import { ProductsId } from '@webc/meeseeks-ui-sdk';

export type RecentSearchCookie = {
  from_uuid: string;
  from_name: string;
  to_uuid: string;
  to_name: string;
  passengers: { [key in ProductsId]?: number };
  departure_date: number;
  return_date: number | null;
};
export const getCookieValueWithRecentSearches = ({
  departureCity,
  arrivalCity,
  products,
  departureDate,
  returnDate,
}: {
  departureCity: CityDetailsResult | PartialSearchMaskLocation;
  arrivalCity: CityDetailsResult | PartialSearchMaskLocation;
  products: Record<string, any>;
  departureDate: number;
  returnDate: number | null;
}): RecentSearchCookie => {
  return {
    from_uuid: departureCity.uuid || '',
    from_name: departureCity.name || '',
    to_uuid: arrivalCity.uuid || '',
    to_name: arrivalCity.name || '',
    passengers: getSelectedProductsAmount(products),
    departure_date: departureDate,
    return_date: returnDate,
  };
};
